// The app's primary blue, so the strip stands out from the dark chrome
export const styleSheet = theme => ({
    container: {
        ...theme.content.blueButton,
        color: theme.colors.white01,
        display: 'block',
        flexShrink: 0,
        padding: '9px 16px',
        textAlign: 'center',
        transition: 'all 0.1s ease-in-out',
        ':hover': {
            ...theme.content.blueButton[':hover'],
            textDecoration: 'none'
        }
    },
    text: {
        lineHeight: '1.3em'
    },
    cta: {
        textDecoration: 'underline',
        whiteSpace: 'nowrap'
    }
});
